<template>
  <div class="wrapper">
    <!-- 1.顶部标题 -->
    <el-row>
      <h3 class="title">
        <div class="block">
          <span>智能填单</span>
        </div>
      </h3>
    </el-row>
    <!-- 3.工具栏 -->
    <el-row>
      <div class="table-tool">
        <el-form class="form-flex" inline size="small" >
          <!-- 搜索内容 -->
          <el-form-item style="margin-right:10px;margin-top:-1px;">
            <el-input class="selectInput" style="width:250px" placeholder="表单名称/所属应用/创建人/状态" v-model="searchField">
              <svg slot="suffix" class="icon" aria-hidden="true" @click="searchFormList">
                <use xlink:href="#iconsearchicon"  />
              </svg>
            </el-input>
          </el-form-item>
          <el-form-item style="margin-top:-1px;margin-right: 0">
            <el-button type="info" icon="el-icon-plus" @click="addNewForm">创建表单模板</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
    <el-scrollbar class="scrollbar-wrap">
    <!-- 3.表格区 -->
    <el-row>
      <el-table style="width:100%;" :data="tableData" tooltip-effect="light">
        <el-table-column
          label="表单名称"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span class="table_span">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="所属应用"
          align="center"
        >
          <template slot-scope="scope">
            <span class="table_span">{{ scope.row.refApp }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="创建人"
          align="center"
        >
          <template slot-scope="scope">
            <span class="table_span">{{ scope.row.createdBy }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span class="table_span">{{ scope.row.createdTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="statue"
          label="状态"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status === '通过审核'" :class="scope.row.status === '通过审核' ? 'text-success' : ''">通过审核</span>
            <span v-if="scope.row.status === '0'" :class="scope.row.status === '0' ? 'text-danger' : ''">下线</span>
            <span v-if="scope.row.status === '待审核'" :class="scope.row.status === '待审核' ? 'text-info' : ''">待审核</span>
          </template>
        </el-table-column>
        <el-table-column
          label="状态更新时间"
          align="center"
          :show-overflow-tooltip="true"
        />
        <el-table-column label="操作" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="light" content="查看" placement="bottom">
              <el-button
                type="text" @click="showForm(scope.row, true)"
              >
                <svg class="icon icon-bianji" aria-hidden="true">
                  <use xlink:href="#iconxiangqing" />
                </svg>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="light" content="编辑" placement="bottom">
              <el-button type="text" @click="showForm(scope.row, false)">
                <svg class="icon icon-bianji" aria-hidden="true">
                  <use xlink:href="#icontable-bianji" />
                </svg>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="light" content="下线" placement="bottom">
              <el-button type="text" @click="offline" >
                <svg class="icon icon-bianji" aria-hidden="true">
                  <use xlink:href="#icontable-bianji" />
                </svg>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="light" content="删除" placement="bottom">
              <el-button type="text" @click="deleteForm(scope.row.id)" >
                <svg class="icon icon-delete" aria-hidden="true">
                  <use xlink:href="#icontable-delete" />
                </svg>
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <!-- 底部分页栏 -->
<!--      <el-row style="float:right;">
        <el-pagination
          background
          class="pageStyle"
          layout="total, prev, pager, next, jumper"
          :page-size.sync="pageSize"
          :current-page.sync="pageNum"
          :total="total"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </el-row>-->

    </el-row>
    </el-scrollbar>
  </div>
</template>
<script>
import { getFormList, deleteForm } from '@/api/autofillform/createAutofillform/autofillformList'
export default {
  name: 'autofillformList',
  data() {
    return {
      tableData: [
      ],
      offlineDialogVisible: false,
      searchField: ''
    }
  },
  props: {
    autofillformFlag: Boolean
  },
  methods: {
    searchFormList () {
      const params = {
        page: 1,
        limit: 999,
        searchField: this.searchField
      }
      getFormList(params).then(response => {
        this.tableData = response.data.data.root
      }).catch(response => {
        this.tableData = []
      })
    },
    addNewForm () {
      this.$emit('changeView', !this.autofillformFlag)
    },
    showForm (item, readOnly) {
      const transParams = {
        item: item,
        readOnly: readOnly
      }
      this.$emit('showItem', transParams, !this.autofillformFlag)
    },
    shenhe () {
      this.$confirm('是否通过该表单审核', '', {
        confirmButtonText: '确 认',
        cancelButtonText: '取 消',
        showClose: false
      })
    },
    offline () {
      this.$confirm('<p style="color: #333;margin-bottom: 10px">是否下线该表单?</p><p style="font-size: 14px;color: #f66f6a"><span class="el-message-box__status el-icon-warning"></span>下线后，自动填单功能将失效</p>', '', {
        confirmButtonText: '确 认',
        cancelButtonText: '取 消',
        dangerouslyUseHTMLString: true,
        type: 'danger',
        showClose: false,
        center: true
      })
    },
    deleteForm (id) {
      this.$confirm('是否确认删除该表单?', '', {
        confirmButtonText: '确 认',
        cancelButtonText: '取 消',
        type: 'warning',
        showClose: false
      }).then(() => {
        const params = {
          id: id
        }
        deleteForm(params).then(response => {
          this.searchFormList()
        }).catch(response => {
          this.tableData = []
        })
      })
    }
  },
  mounted() {
    this.searchFormList()
  }
}
</script>
<style lang="scss">
 .table-tool{margin:10px 0 4px;}
</style>
<style lang="scss" scoped>
  .wrapper {
    height: 100%;
  }
  .scrollbar-wrap {
    height: calc(100% - 61px - 78px);
  }
  .form-flex {
    display: flex;
    justify-content: space-between;
  }
</style>
